import moment from "moment/moment";
import KEYS from "../env/env";
// import secureLocalStorage from "react-secure-storage";
import { config } from "./config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showToast } from "../redux/slices/ToastSlice";
import { designTypesEnum } from "../enums";

export const doRequest = async (data, method, action) => {
    var myHeaders = new Headers();
    // let token = secureLocalStorage.getItem("Login");
    let token = localStorage.getItem("Login");
    myHeaders.append("Content-Type", "application/json");
    if (token) {
        myHeaders.append("Authorization", `Bearer ${token}`);
    }
    if (data) {
        var raw = JSON.stringify(data);
    }

    var requestOptions = {
        method: method ? method : "POST",
        headers: myHeaders,
        redirect: "follow",
    };
    if (method === "POST") {
        requestOptions["body"] = raw;
    }

    let response = await fetch(`${KEYS.apiPath}${action}`, requestOptions);

    if (response.status === 401) {
        window.location.href = "/login";
        localStorage.clear();
        return false;
    }

    let result = await response.json();
    return result;
};

export const dataURLToBlob = (dataURL) => {
    const byteString = atob(dataURL?.split(",")[1]);
    const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString?.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString?.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
};

export const userID = () => {
    if (JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS))) {
        return JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS)).id;
    } else {
        return;
    }
};

export const getNormalDateFormate = (dateStr) => {
    const date = moment(dateStr).format("DD-MM-YYYY");
    return date;
};

export const dimensionsOld = {
    XS: { width: 5700, height: 8100, size: 34 }, //34 size
    S: { width: 6000, height: 8526, size: 36 }, //36 size
    M: { width: 6300, height: 8953, size: 38 }, //38 size
    L: { width: 6600, height: 9379, size: 40 }, //40 size
    // L: { width: 6600, height: 9000, size: 40 }, //40 size
    XL: { width: 6900, height: 9805, size: 42 }, //42 size
    "2XL": { width: 7200, height: 10232, size: 44 }, //44 size
    "3XL": { width: 7500, height: 10658, size: 46 }, //46 size
    "4XL": { width: 7800, height: 11084, size: 48 }, //48 size
    "5XL": { width: 8100, height: 11511, size: 50 }, // 50size
    "6XL": { width: 8400, height: 11937, size: 52 }, //52 size
};

function importAll(r) {
    let files = [];
    r.keys().map((item, index) => {
        files.push(item.replace("./", ""));
    });
    return files;
}

export const fonts = importAll(
    require.context(
        "../../public/assets/fonts/teedexFontsFiles",
        false,
        /\.(ttf|otf|woff|woff2)$/
    )
);

export const dimensionsKonva = {
    "1-2 Yr": { width: 4035, height: 5733, size: 19 },
    "3 Yr": { width: 4222, height: 6000, size: 20 },
    "4 Yr": { width: 4433, height: 6300, size: 21 },
    "5-6 Yr": { width: 4651, height: 6608, size: 22 },
    "7-8 Yr": { width: 4856, height: 6900, size: 23 },
    "9-10 Yr": { width: 5401, height: 7674, size: 24 },
    "11-12 Yr": { width: 5489, height: 7800, size: 26 },
    XS: { width: 5700, height: 8100, size: 34 }, //34 size
    S: { width: 6000, height: 8526, size: 36 }, //36 size
    M: { width: 6300, height: 8953, size: 38 }, //38 size
    L: { width: 6600, height: 9379, size: 40 }, //40 size
    // L: { width: 6600, height: 9000, size: 40 }, //40 size
    XL: { width: 6900, height: 9805, size: 42 }, //42 size
    "2XL": { width: 7200, height: 10232, size: 44 }, //44 size
    "3XL": { width: 7500, height: 10658, size: 46 }, //46 size
    "4XL": { width: 7800, height: 11084, size: 48 }, //48 size
    "5XL": { width: 8100, height: 11511, size: 50 }, // 50size
    "6XL": { width: 8400, height: 11937, size: 52 }, //52 size
};

export const dimensions = {
    "1-2 Yr": {
        width: 3750,
        height: 5700,
        size: 20,
        inchWidth: "12.5",
        inchHeight: "19",
        inch: "12.5 X 19 in",
    },
    "3 Yr": {
        width: 4050,
        height: 6000,
        size: 22,
        inchWidth: "13.5",
        inchHeight: "20",
        inch: "13.5 X 20 in",
    },
    "4 Yr": {
        width: 4350,
        height: 6300,
        size: 24,
        inchWidth: "14.5",
        inchHeight: "21",
        inch: "14.5 X 21 in",
    },
    "5-6 Yr": {
        width: 4650,
        height: 6600,
        size: 26,
        inchWidth: "15.5",
        inchHeight: "22",
        inch: "15.5 X 22 in",
    },
    "7-8 Yr": {
        width: 4800,
        height: 6900,
        size: 28,
        inchWidth: "16",
        inchHeight: "23",
        inch: "16 X 23 in",
    },
    "9-10 Yr": {
        width: 5400,
        height: 7200,
        size: 30,
        inchWidth: "18",
        inchHeight: "24",
        inch: "18 X 24 in",
    },
    "11-12 Yr": {
        width: 5400,
        height: 7800,
        size: 32,
        inchWidth: "18",
        inchHeight: "26",
        inch: "18 X 26 in",
    },
    XS: {
        width: 5700,
        height: 8100,
        size: 34,
        inchWidth: "19",
        inchHeight: "27",
        inch: "19 X 27 in",
    }, //34 size
    S: {
        width: 6000,
        height: 8400,
        size: 36,
        inchWidth: "20",
        inchHeight: "28",
        inch: "20 X 28 in",
    }, //36 size
    M: {
        width: 6300,
        height: 8700,
        size: 38,
        inchWidth: "21",
        inchHeight: "29",
        inch: "21 X 29 in",
    }, //38 size
    L: {
        width: 6600,
        height: 9000,
        size: 40,
        inchWidth: "22",
        inchHeight: "30",
        inch: "22 X 30 in",
    }, //40 size
    // L: { width: 6600, height: 9000, size: 40 }, //40 size
    XL: {
        width: 6900,
        height: 9300,
        size: 42,
        inchWidth: "23",
        inchHeight: "31",
        inch: "23 X 31 in",
    }, //42 size
    "2XL": {
        width: 7200,
        height: 9600,
        size: 44,
        inchWidth: "24",
        inchHeight: "32",
        inch: "24 X 32 in",
    }, //44 size
    "3XL": {
        width: 7500,
        height: 9900,
        size: 46,
        inchWidth: "25",
        inchHeight: "33",
        inch: "25 X 33 in",
    }, //46 size
    "4XL": {
        width: 7800,
        height: 10200,
        size: 48,
        inchWidth: "26",
        inchHeight: "34",
        inch: "26 X 34 in",
    }, //48 size
    "5XL": {
        width: 8100,
        height: 10500,
        size: 50,
        inchWidth: "27",
        inchHeight: "35",
        inch: "27 X 35 in",
    }, // 50size
    "6XL": {
        width: 8400,
        height: 10500,
        size: 52,
        inchWidth: "28",
        inchHeight: "35",
        inch: "28 X 35 in",
    }, //52 size
};

export const halfSleevesDimensions = {
    "1-2 Yr": {
        width: 3600,
        height: 2100,
        size: 20,
        inchWidth: "12.5",
        inchHeight: "19",
        inch: "12.5 X 19 in",
    },
    "3 Yr": {
        width: 3900,
        height: 2250,
        size: 22,
        inchWidth: "13.5",
        inchHeight: "20",
        inch: "13.5 X 20 in",
    },
    "4 Yr": {
        width: 4050,
        height: 2250,
        size: 24,
        inchWidth: "14.5",
        inchHeight: "21",
        inch: "14.5 X 21 in",
    },
    "5-6 Yr": {
        width: 4650,
        height: 6600,
        size: 26,
        inchWidth: "15.5",
        inchHeight: "22",
        inch: "15.5 X 22 in",
    },
    "7-8 Yr": {
        width: 4800,
        height: 6900,
        size: 28,
        inchWidth: "16",
        inchHeight: "23",
        inch: "16 X 23 in",
    },
    "9-10 Yr": {
        width: 5400,
        height: 7200,
        size: 30,
        inchWidth: "18",
        inchHeight: "24",
        inch: "18 X 24 in",
    },
    "11-12 Yr": {
        width: 5400,
        height: 7800,
        size: 32,
        inchWidth: "18",
        inchHeight: "26",
        inch: "18 X 26 in",
    },
    XS: {
        width: 5700,
        height: 8100,
        size: 34,
        inchWidth: "19",
        inchHeight: "27",
        inch: "19 X 27 in",
    }, //34 size
    S: {
        width: 6000,
        height: 8400,
        size: 36,
        inchWidth: "20",
        inchHeight: "28",
        inch: "20 X 28 in",
    }, //36 size
    M: {
        width: 6300,
        height: 8700,
        size: 38,
        inchWidth: "21",
        inchHeight: "29",
        inch: "21 X 29 in",
    }, //38 size
    L: {
        width: 6600,
        height: 9000,
        size: 40,
        inchWidth: "22",
        inchHeight: "30",
        inch: "22 X 30 in",
    }, //40 size
    // L: { width: 6600, height: 9000, size: 40 }, //40 size
    XL: {
        width: 6900,
        height: 9300,
        size: 42,
        inchWidth: "23",
        inchHeight: "31",
        inch: "23 X 31 in",
    }, //42 size
    "2XL": {
        width: 7200,
        height: 9600,
        size: 44,
        inchWidth: "24",
        inchHeight: "32",
        inch: "24 X 32 in",
    }, //44 size
    "3XL": {
        width: 7500,
        height: 9900,
        size: 46,
        inchWidth: "25",
        inchHeight: "33",
        inch: "25 X 33 in",
    }, //46 size
    "4XL": {
        width: 7800,
        height: 10200,
        size: 48,
        inchWidth: "26",
        inchHeight: "34",
        inch: "26 X 34 in",
    }, //48 size
    "5XL": {
        width: 8100,
        height: 10500,
        size: 50,
        inchWidth: "27",
        inchHeight: "35",
        inch: "27 X 35 in",
    }, // 50size
    "6XL": {
        width: 8400,
        height: 10500,
        size: 52,
        inchWidth: "28",
        inchHeight: "35",
        inch: "28 X 35 in",
    }, //52 size
};

export const plansId = {
    free: "1",
    variation: "2",
    premium: "3",
};

export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const submitUserPlans = async (planid, user, invoice) => {
    if (!planid) return;
    let data = {
        user_id: user?.id,
        plan_id: planid,
    };

    if (invoice) {
        data["invoice_no"] = invoice;
    }
    let response = await doRequest(data, "POST", "plan/update");
    return response;
};

export const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttarakhand",
    "Uttar Pradesh",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry",
];

export const numberToWords = (num) => {
    if (num === 0) return "Zero";

    const belowTwenty = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
    ];
    const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
    ];
    const thousands = ["", "Thousand", "Million", "Billion"];

    function helper(n) {
        if (n === 0) return "";
        if (n < 20) return belowTwenty[n] + " ";
        if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
        if (n < 1000)
            return (
                belowTwenty[Math.floor(n / 100)] + " Hundred " + helper(n % 100)
            );
        for (let i = 0; i < thousands.length; i++) {
            const unit = 1000 ** i;
            if (n < unit * 1000) {
                return (
                    helper(Math.floor(n / unit)) +
                    thousands[i] +
                    " " +
                    helper(n % unit)
                );
            }
        }
    }

    return helper(num).trim();
};

export const fontOptions = [
    { value: "Arial", label: "Arial" },
    { value: "Times New Roman", label: "Times New Roman" },
    { value: "Euclid Circular A", label: "Euclid Circular A" },
    { value: "Medium", label: "Medium" },
    { value: "BlinkMacSystemFont", label: "BlinkMacSystemFont" },
    { value: "Segoe UI", label: "Segoe UI" },
    { value: "Ubuntu", label: "Ubuntu" },
    { value: "Cantarell", label: "Cantarell" },
    { value: "Fira Sans", label: "Fira Sans" },
    { value: "Droid Sans", label: "Droid Sans" },
    { value: "Helvetica Neue", label: "Helvetica Neue" },
    { value: "American Captain", label: "American Captain" },
    { value: "Bruce Forever", label: "Bruce Forever" },
    { value: "Freshman", label: "Freshman" },
    { value: "Govrnment Agent BB", label: "Govrnment Agent BB" },
    { value: "Govrnment Agent BB Italic", label: "Govrnment Agent BB Italic" },
    { value: "Jersey M54", label: "Jersey M54" },
    { value: "Rozha One", label: "Rozha One" },
    { value: "Sports Jersey", label: "Sports Jersey" },
    { value: "Sports World", label: "Sports World" },
    { value: "atlanta_collegeregular", label: "ATLANTA COLLEGE REGULAR" },

    // Add more font options as needed
];

export const capitalizeFirstLetter = (text) => {
    return text
        ?.split(" ")
        .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
};

export const base64ToFile = async (imge) => {
    const res = await fetch(imge);
    const blob = await res.blob();
    const file = new File([blob], `image.jpg`, {
        type: "image/jpg",
    });
    return file;
    // fetch(imge)
    //   .then((res) => res.blob())
    //   .then((blob) => {
    //     console.log('blob is', blob)
    //     return new File([blob], `image.png`, {
    //       type: "image/png",
    //     });
    //   });
};

export function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (event) {
            const base64String = event.target.result;
            resolve(base64String);
        };
        reader.onerror = reject;
    });
}

export const imageFileToBlob = (file) => {
    if (file) {
        const blobUrl = URL.createObjectURL(file);
        return blobUrl;
    }
};

export const sizeExcel = {
    "20 1-2 Yr": "1-2 Yr",
    "22 3 Yr": "3 Yr",
    "24 4 Yr": "4 Yr",
    "26 5-6 Yr": "5-6 Yr",
    "28 7-8 Yr": "7-8 Yr",
    "30 9-10 Yr": "9-10 Yr",
    "32 11-12 Yr": "11-12 Yr",
    "34 XS": "XS",
    "36 S": "S",
    "38 M": "M",
    "40 L": "L",
    "40  L": "L",
    " 40 L": "L",
    "42 XL": "XL",
    "44 2XL": "2XL",
    "46 3XL": "3XL",
    "48 4XL": "4XL",
    "50 5XL": "5XL",
    "52 6XL": "6XL",
};

export const teeShirt_size = [
    { value: "1-2 Yr", lable: "20 1-2 Yr" },
    { value: "3 Yr", lable: "22 3 Yr" },
    { value: "4 Yr", lable: "24 4 Yr" },
    { value: "5-6 Yr", lable: "26 5-6 Yr" },
    { value: "7-8 Yr", lable: "28 7-8 Yr" },
    { value: "9-10 Yr", lable: "30 9-10 Yr" },
    { value: "11-12 Yr", lable: "32 11-12 Yr" },
    { value: "XS", lable: "34 XS" },
    { value: "S", lable: "36 S" },
    { value: "M", lable: "38 M" },
    { value: "L", lable: "40 L" },
    { value: "XL", lable: "42 XL" },
    { value: "2XL", lable: "44 2XL" },
    { value: "3XL", lable: "46 3XL" },
    { value: "4XL", lable: "48 4XL" },
    { value: "5XL", lable: "50 5XL" },
    { value: "6XL", lable: "52 6XL" },
];

export const teeShirt_size_obj = {
    0: { value: "1-2 Yr", lable: "1-2 Yr" },
    1: { value: "3 Yr", lable: "3 Yr" },
    2: { value: "4 Yr", lable: "4 Yr" },
    3: { value: "5-6 Yr", lable: "5-6 Yr" },
    4: { value: "7-8 Yr", lable: "7-8 Yr" },
    5: { value: "9-10 Yr", lable: "9-10 Yr" },
    6: { value: "11-12 Yr", lable: "11-12 Yr" },
    7: { value: "XS", lable: "XS" },
    8: { value: "S", lable: "S" },
    9: { value: "M", lable: "M" },
    10: { value: "L", lable: "L" },
    11: { value: "XL", lable: "XL" },
    12: { value: "2XL", lable: "2XL" },
    13: { value: "3XL", lable: "3XL" },
    14: { value: "4XL", lable: "4XL" },
    15: { value: "5XL", lable: "5XL" },
    16: { value: "6XL", lable: "6XL" },
};

export const getSubscriptionStatus = (planDetails) => {
    const endDate = planDetails?.end_date;
    const today = moment();
    const end = moment(endDate);

    if (!planDetails || !planDetails.subscription_status) {
        return "Loading subscription...";
      }
    if (planDetails?.subscription_status !== 'active') {
        return "Subscription expired";
    }
    const diffDays = end.diff(today, "days");

    return diffDays >= 0 ? `${diffDays + 1} days left` : "Subscription expired";
};

export const getSubscriptionDaysDiff = (endDate) => {
    const today = moment();
    const end = moment(endDate);

    // Calculate difference in days

    const diffDays = end.diff(today, "days");

    return diffDays;
};

export const designWiseSizeDimensions = {
    back: {
        "1-2 Yr": {
            width: 3750,
            height: 5700,
            size: 20,
            inchWidth: "12.5",
            inchHeight: "19",
            inch: "12.5 X 19 in",
        },
        "3 Yr": {
            width: 4050,
            height: 6000,
            size: 22,
            inchWidth: "13.5",
            inchHeight: "20",
            inch: "13.5 X 20 in",
        },
        "4 Yr": {
            width: 4350,
            height: 6300,
            size: 24,
            inchWidth: "14.5",
            inchHeight: "21",
            inch: "14.5 X 21 in",
        },
        "5-6 Yr": {
            width: 4650,
            height: 6600,
            size: 26,
            inchWidth: "15.5",
            inchHeight: "22",
            inch: "15.5 X 22 in",
        },
        "7-8 Yr": {
            width: 4800,
            height: 6900,
            size: 28,
            inchWidth: "16",
            inchHeight: "23",
            inch: "16 X 23 in",
        },
        "9-10 Yr": {
            width: 5400,
            height: 7200,
            size: 30,
            inchWidth: "18",
            inchHeight: "24",
            inch: "18 X 24 in",
        },
        "11-12 Yr": {
            width: 5400,
            height: 7800,
            size: 32,
            inchWidth: "18",
            inchHeight: "26",
            inch: "18 X 26 in",
        },
        XS: {
            width: 5700,
            height: 8100,
            size: 34,
            inchWidth: "19",
            inchHeight: "27",
            inch: "19 X 27 in",
        }, //34 size
        S: {
            width: 6000,
            height: 8400,
            size: 36,
            inchWidth: "20",
            inchHeight: "28",
            inch: "20 X 28 in",
        }, //36 size
        M: {
            width: 6300,
            height: 8700,
            size: 38,
            inchWidth: "21",
            inchHeight: "29",
            inch: "21 X 29 in",
        }, //38 size
        L: {
            width: 6600,
            height: 9000,
            size: 40,
            inchWidth: "22",
            inchHeight: "30",
            inch: "22 X 30 in",
        }, //40 size
        // L: { width: 6600, height: 9000, size: 40 }, //40 size
        XL: {
            width: 6900,
            height: 9300,
            size: 42,
            inchWidth: "23",
            inchHeight: "31",
            inch: "23 X 31 in",
        }, //42 size
        "2XL": {
            width: 7200,
            height: 9600,
            size: 44,
            inchWidth: "24",
            inchHeight: "32",
            inch: "24 X 32 in",
        }, //44 size
        "3XL": {
            width: 7500,
            height: 9900,
            size: 46,
            inchWidth: "25",
            inchHeight: "33",
            inch: "25 X 33 in",
        }, //46 size
        "4XL": {
            width: 7800,
            height: 10200,
            size: 48,
            inchWidth: "26",
            inchHeight: "34",
            inch: "26 X 34 in",
        }, //48 size
        "5XL": {
            width: 8100,
            height: 10500,
            size: 50,
            inchWidth: "27",
            inchHeight: "35",
            inch: "27 X 35 in",
        }, // 50size
        "6XL": {
            width: 8400,
            height: 10500,
            size: 52,
            inchWidth: "28",
            inchHeight: "35",
            inch: "28 X 35 in",
        }, //52 size
    },
    halfSleeves: {
        "1-2 Yr": {
            width: 3600,
            height: 2100,
            size: 20,
            inchWidth: "12.5",
            inchHeight: "7",
            inch: "12.5 X 7 in",
        },
        "3 Yr": {
            width: 3900,
            height: 2250,
            size: 22,
            inchWidth: "13",
            inchHeight: "7.5",
            inch: "13 X 7.5 in",
        },
        "4 Yr": {
            width: 4050,
            height: 2250,
            size: 24,
            inchWidth: "13.5",
            inchHeight: "7.5",
            inch: "13.5 X 7.5 in",
        },
        "5-6 Yr": {
            width: 4200,
            height: 2400,
            size: 26,
            inchWidth: "14",
            inchHeight: "8",
            inch: "14 X 8 in",
        },
        "7-8 Yr": {
            width: 4350,
            height: 2475,
            size: 28,
            inchWidth: "14.5",
            inchHeight: "8.25",
            inch: "14.5 X 8.25",
        },
        "9-10 Yr": {
            width: 4500,
            height: 2550,
            size: 30,
            inchWidth: "15",
            inchHeight: "8.5",
            inch: "15 X 8.5 in",
        },
        "11-12 Yr": {
            width: 4650,
            height: 2625,
            size: 32,
            inchWidth: "15.5",
            inchHeight: "8.75",
            inch: "15.5 X 8.75",
        },
        XS: {
            width: 4950,
            height: 2850,
            size: 34,
            inchWidth: "16.5",
            inchHeight: "9.5",
            inch: "16.5 X 9.5 in",
        }, //34 size
        S: {
            width: 5100,
            height: 3075,
            size: 36,
            inchWidth: "17",
            inchHeight: "10.25",
            inch: "17 X 10.25 in",
        }, //36 size
        M: {
            width: 5250,
            height: 3150,
            size: 38,
            inchWidth: "17.5",
            inchHeight: "10.5",
            inch: "17.5 X 10.5 in",
        }, //38 size
        L: {
            width: 5700,
            height: 3225,
            size: 40,
            inchWidth: "19",
            inchHeight: "10.75",
            inch: "19 X 10.75 in",
        }, //40 size
        // L: { width: 6600, height: 9000, size: 40 }, //40 size
        XL: {
            width: 6000,
            height: 3450,
            size: 42,
            inchWidth: "20",
            inchHeight: "11.5",
            inch: "20 X 11.5 in",
        }, //42 size
        "2XL": {
            width: 6150,
            height: 3600,
            size: 44,
            inchWidth: "20.5",
            inchHeight: "12",
            inch: "20.5 X 12 in",
        }, //44 size
        "3XL": {
            width: 6300,
            height: 3750,
            size: 46,
            inchWidth: "21",
            inchHeight: "12.5",
            inch: "21 X 12.5 in",
        }, //46 size
        "4XL": {
            width: 6450,
            height: 3900,
            size: 48,
            inchWidth: "21.5",
            inchHeight: "13",
            inch: "21.5 X 13 in",
        }, //48 size
        "5XL": {
            width: 6600,
            height: 4050,
            size: 50,
            inchWidth: "22",
            inchHeight: "13.5",
            inch: "22 X 13.5 in",
        }, // 50size
        "6XL": {
            width: 6750,
            height: 4200,
            size: 52,
            inchWidth: "22.5",
            inchHeight: "14",
            inch: "22.5 X 14 in",
        }, //52 size
    },
    fullSleeves: {
        "1-2 Yr": {
            width: 3600,
            height: 2100,
            size: 20,
            inchWidth: "12.5",
            inchHeight: "20",
            inch: "12.5 X 20 in",
        },
        "3 Yr": {
            width: 3900,
            height: 2250,
            size: 22,
            inchWidth: "13",
            inchHeight: "21",
            inch: "13 × 21 in",
        },
        "4 Yr": {
            width: 4050,
            height: 2250,
            size: 24,
            inchWidth: "13.5",
            inchHeight: "22",
            inch: "13.5 × 22 in",
        },
        "5-6 Yr": {
            width: 4200,
            height: 2400,
            size: 26,
            inchWidth: "14",
            inchHeight: "22",
            inch: "14 × 22in",
        },
        "7-8 Yr": {
            width: 4350,
            height: 2475,
            size: 28,
            inchWidth: "15",
            inchHeight: "23",
            inch: "15 × 23 in",
        },
        "9-10 Yr": {
            width: 4500,
            height: 2550,
            size: 30,
            inchWidth: "15.5",
            inchHeight: "23.5",
            inch: "15.5 × 23.5 in",
        },
        "11-12 Yr": {
            width: 4650,
            height: 2625,
            size: 32,
            inchWidth: "16",
            inchHeight: "24",
            inch: "16 × 24 in",
        },
        XS: {
            width: 4950,
            height: 2850,
            size: 34,
            inchWidth: "16.5",
            inchHeight: "24.5",
            inch: "16.5 × 24.5in",
        }, //34 size
        S: {
            width: 5100,
            height: 3075,
            size: 36,
            inchWidth: "17",
            inchHeight: "25",
            inch: "17 × 25 in",
        }, //36 size
        M: {
            width: 5250,
            height: 3150,
            size: 38,
            inchWidth: "17.5",
            inchHeight: "25",
            inch: "17.5 × 25in",
        }, //38 size
        L: {
            width: 5700,
            height: 3225,
            size: 40,
            inchWidth: "19",
            inchHeight: "26",
            inch: "19 × 26 in",
        }, //40 size
        // L: { width: 6600, height: 9000, size: 40 }, //40 size
        XL: {
            width: 6000,
            height: 3450,
            size: 42,
            inchWidth: "20",
            inchHeight: "26",
            inch: "20 × 26in",
        }, //42 size
        "2XL": {
            width: 6150,
            height: 3600,
            size: 44,
            inchWidth: "20.5",
            inchHeight: "26.5",
            inch: "20.5 × 26.5 in",
        }, //44 size
        "3XL": {
            width: 6300,
            height: 3750,
            size: 46,
            inchWidth: "21",
            inchHeight: "26.5",
            inch: "21 × 26.5 in",
        }, //46 size
        "4XL": {
            width: 6450,
            height: 3900,
            size: 48,
            inchWidth: "21.5",
            inchHeight: "27",
            inch: "21.5 × 27 in",
        }, //48 size
        "5XL": {
            width: 6600,
            height: 4050,
            size: 50,
            inchWidth: "22",
            inchHeight: "27.5",
            inch: "22 × 27.5 in",
        }, // 50size
        "6XL": {
            width: 6750,
            height: 4200,
            size: 52,
            inchWidth: "22.5",
            inchHeight: "27.5",
            inch: "22.5 × 27.5 in",
        }, //52 size
    },
    a4: {
        width: 3600,
        height: 2100,
        size: "a4",
        inchWidth: "18.3",
        inchHeight: "11.7",
        inch: "18.3 x 11.7 in",
    },
};

export const clearGrid = (store) => {
    store.pages.forEach((page) => {
        const gridElements = page.children.filter((el) => el.name === "grid");
        store.deleteElements(gridElements.map((el) => el.id));
    });
};

export const addExternalText = (store) => {
    const page = store.activePage;
    if (!page) return;

    store.history.transaction(() => {
        page.addElement({
            id: `external-text-${Date.now()}`, // Unique ID to ensure a new element is always created
            type: "text",
            text: "New Text",
            fontSize: 100,
            fontFamily: "Arial",
            fill: "black",
            x: 573,
            y: 1654,
            visible: true,
            width: 365,
            height: 241,
            lineHeight: 1.2,
        });
    });
};

export const getTabNAmeByPanel = (panel) => {
    let p = panel?.toLowerCase();
    if (p === "upload") {
        return "upload";
    }
    if (p === "elements") {
        return "elements";
    }
    if (p === "text") {
        return "custom-text";
    }
    if (p === "grid") {
        return "custom-grid";
    }
    if (p === "layers") {
        return "layers";
    }
};

export const getPanelNameByTab = (tab) => {
    let p = tab?.toLowerCase();
    if (p === "upload") {
        return "upload";
    }
    if (p === "elements") {
        return "elements";
    }
    if (p === "custom-text") {
        return "text";
    }
    if (p === "custom-grid") {
        return "grid";
    }
    if (p === "layers") {
        return "layers";
    }
};

export const getApplyLocalStoreState = (type) => {
    if (type === "halfSleeves") {
        return "applyAllClickStatushalfSleeves";
    }
    if (type === "back") {
        return "applyAllClickStatusTees";
    }

    if (type === "fullSleeves") {
        return "applyAllClickStatusfullSleeves";
    }
};

export const textItemRender = (current, type, element) => {
    if (type === "prev") {
        return (
            <FontAwesomeIcon
                icon={["fas", "chevron-left"]}
                className="font-size-sm"
            />
        );
    }
    if (type === "next") {
        return (
            <FontAwesomeIcon
                icon={["fas", "chevron-right"]}
                className="font-size-sm"
            />
        );
    }
    return element;
};
export function changeFontFamilyForAllTextboxes(newFontFamily, store) {
    console.log("store?.selectedElements", store?.selectedElements);
    if (store?.selectedElements.length > 1) {
        store.selectedElements
            .filter((el) => el.type === "text")
            .forEach((textbox) => {
                textbox.set({ fontFamily: newFontFamily });
            });
    } else if (
        store?.selectedElements.length > 0 &&
        store?.selectedElements.length < 2
    ) {
        store?.selectedElements[0]?.set({ fontFamily: newFontFamily });
    }
}

export const canUserDownloadImage = (
    planDetails,
    variantToDownload,
    dispatch
) => {
    // subscription_status
    // if (!planDetails || planDetails?.status !== "active") {
    //     dispatch(
    //         showToast({
    //             message: "You don't have any active plan",
    //             type: "error",
    //         })
    //     );
    //     return false;
    // }
    const userCurrPlanId = planDetails?.plan_id;
    let planStatus;
    if (userCurrPlanId === 5 || userCurrPlanId === 1) {
        planStatus = planDetails?.plan_status;
    } else {
        planStatus = planDetails?.subscription_status
    }
    if (planStatus === "inactive") {
        dispatch(
            showToast({
                message: "You don't have any active plan",
                type: "error",
            })
        );
        return false;
    }

    if (+planDetails?.plan_id > 5) {
        return true;
    }

    if (+planDetails?.plan_id === 5 || +planDetails?.plan_id === 1) {
        const userCanDownloadImages = planDetails?.total_variant - planDetails?.variant_count;
        if (variantToDownload > userCanDownloadImages) {
            dispatch(
                showToast({
                    message:
                        userCanDownloadImages > 0
                            ? `You can download ${userCanDownloadImages} variations only`
                            : "You can not download more images",
                    type: "error",
                })
            );
            return false;
        }
    }
    return true;
};

// export const canUserDownloadImage = (
//     planDetails,
//     variantDetails,
//     dispatch,
//     tshirtDetails,
//     checkForAll
// ) => {
//     if (planDetails && planDetails?.status === "active") {
//         return true;
//     }

//     if (!planDetails || planDetails?.status !== "active") {
//         dispatch(
//             showToast({
//                 message: "You don't have any active plan",
//                 type: "error",
//             })
//         );
//         return false;
//     }
//     let status = getSubscriptionStatus(planDetails?.end_date);
//     if (status === "Subscription expired") {
//         dispatch(
//             showToast({
//                 message: "Subscription expired",
//                 type: "error",
//             })
//         );
//         return;
//     }

//     let count =
//         parseInt(variantDetails?.total_variant) -
//         parseInt(variantDetails?.variant_count);

//     if (planDetails?.type?.toLowerCase() !== "unlimited") {
//         if (count < 1) {
//             dispatch(
//                 showToast({
//                     message: "You have not enough count left",
//                     type: "error",
//                 })
//             );
//             return false;
//         }
//     }

//     if (checkForAll) {
//         let totalDownloads = tshirtDetails?.length || 0;
//         if (count < totalDownloads) {
//             dispatch(
//                 showToast({
//                     message: `You have not enough count left. You can download ${count} images only!`,
//                     type: "error",
//                 })
//             );
//             return false;
//         }
//     }

//     return true;
// };

// Helper function to determine if error is retryable
export const isRetryableError = (error) => {
    const retryableStatuses = [408, 429, 500, 502, 503, 504];
    return (
        retryableStatuses.includes(error.status) ||
        error.message.includes("network") ||
        error.message.includes("timeout")
    );
};

// Better download handling to avoid popup blockers
export const downloadFile = (url) => {
    // Method 1: Use anchor element (preferred)
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // Force download
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Fallback: If anchor doesn't work, use window.open
    setTimeout(() => {
        if (!link.downloaded) {
            window.open(url, "_blank");
        }
    }, 1000);
};
// Checks if the provided value is one of the paper sizes (A4, A3, A2, A1) or custom
export const isPaperSizeType = (value) => {
    return [
        designTypesEnum.A4,
        designTypesEnum.A3,
        designTypesEnum.A2,
        designTypesEnum.A1,
        designTypesEnum.CUSTOM,
    ].includes(value);
};

export function getCenteredCrop(imgWidth, imgHeight, frameWidth, frameHeight) {
  const imgRatio = imgWidth / imgHeight;
  const frameRatio = frameWidth / frameHeight;
  let cropX, cropY, cropWidth, cropHeight;

  if (imgRatio > frameRatio) {
    // Image wider than frame
    cropHeight = 1;
    cropWidth = frameRatio / imgRatio;
    cropX = (1 - cropWidth) / 2;
    cropY = 0;
  } else {
    // Image taller than frame
    cropWidth = 1;
    cropHeight = imgRatio / frameRatio;
    cropX = 0;
    cropY = (1 - cropHeight) / 2;
  }

  return { cropX, cropY, cropWidth, cropHeight };
}

export function isFitToPageEnabled(masterPage, masterData){
    if(!masterPage || !Object.keys(masterPage)?.length) return
    return masterPage.width === masterData?.width && masterPage.height === masterData?.height;
}


export const changeDocumentTitle = (name) => {
      document.title = name ? `${name} - Teedex` : "Teedex";
}

export function isPlanExpired(planDetails){
    const endDate = planDetails?.end_date;
    const today = moment();
    const end = moment(endDate);
    if (planDetails?.subscription_status !== 'active') {
        return true;
    }

    const diffDays = end.diff(today, "days");
    return diffDays < 0;
}

export const isNewFont = (createdAt) => {
    const createdTime = new Date(createdAt).getTime();
    const now = Date.now();
    const THREE_DAYS = 3 * 24 * 60 * 60 * 1000;
    return now - createdTime <= THREE_DAYS;
  };
  